import { type ReactNode } from "react";
import { IconType } from "../icon/IconType";
import { Icon } from "../icon/Icon";
import {
  Accordion as MuiExpansionPanel,
  AccordionDetails as MuiExpansionPanelDetails,
  AccordionSummary as MuiExpansionPanelSummary,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { IconSize } from "../icon/IconSize";
import { C_ON_SURFACE, C_OUTLINE_VARIANT } from "../icon/Colors";
import { FontSize, getFontStyle } from "../materialInput/Fonts";

const ExpansionPanel = withStyles({
  root: {
    borderRadius: 0,
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
    borderTop: `1px solid ${C_OUTLINE_VARIANT}`,
    "&:last-child": {
      borderBottom: `1px solid ${C_OUTLINE_VARIANT}`,
    },
    "&$expanded": {
      margin: 0,
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelDetails = withStyles({
  root: {
    color: C_ON_SURFACE,
    paddingLeft: "10px",
  },
})(MuiExpansionPanelDetails);

const ExpansionPanelSummary = withStyles({
  root: {
    minHeight: 0,
    color: C_ON_SURFACE,
    paddingLeft: "10px",
    ...getFontStyle(FontSize.BodyMedium),
    "&$expanded": {
      minHeight: 0,
    },
  },
  content: {
    margin: "10px 0",
    "&$expanded": {
      margin: "10px 0",
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

export const Expandable = (props: ExpandableProps) => (
  <ExpansionPanel>
    <ExpansionPanelSummary expandIcon={<Icon size={IconSize.FONT_20} type={IconType.ChevronDown} />}>
      {props.summary}
    </ExpansionPanelSummary>
    <ExpansionPanelDetails>{props.expandedDetails}</ExpansionPanelDetails>
  </ExpansionPanel>
);

export interface ExpandableProps {
  summary: ReactNode;
  expandedDetails: ReactNode;
}
